import { Email } from '@sales-app/types/Email'
import { gql } from 'graphql-request'

export namespace EmailQueries {
  export namespace GET_EMAIL {
    export type Response = { email: Email | null }
  }
  export function getEmail() {
    return gql`
      query getEmail($emailId: Int!) {
        email(emailId: $emailId) {
          historyId
          id
          internalDate
          labelIds
          payload {
            body {
              attachmentId
              data
              size
            }
            filename
            headers {
              name
              value
            }
            mimeType
            partId
            parts {
              body {
                attachmentId
                data
                size
              }
              filename
              headers {
                name
                value
              }
              mimeType
              partId
            }
          }
          sizeEstimate
          threadId
        }
      }
    `
  }
}
